import React from 'react';
import { Alert } from 'reactstrap';

const CreditCardPreview = ({ cardVisual, isFlipped, getCardBackground, hideSecurityNote = false }) => (
    <div className="position-sticky" style={{ top: 20 }}>
        <div className="credit-card-stage">
            <div className={`credit-card ${isFlipped ? 'is-flipped' : ''}`}>
                {/* FRONT */}
                <div className="credit-card__face credit-card__face--front" style={{ background: getCardBackground(), color: '#2c3e50' }}>
                    <div className="cc-shine" />
                    <div className="cc-holographic" />
                    <div className="cc-glow" />
                    <div className="cc-sparkles" />
                    <div className="cc-row cc-top">
                        <div className="cc-chip" style={{ color: '#1976d2' }}>▦</div>
                        <div className="cc-bank">
                            {cardVisual.bankLogo
                                ? <img src={cardVisual.bankLogo} width={100} height={32} style={{ objectFit: 'contain' }} alt={cardVisual.bank} />
                                : <span>{cardVisual.bank}</span>}
                        </div>
                    </div>
                    <div className="cc-number" style={{ color: '#2c3e50', textShadow: '0 1px 0 rgba(255,255,255,.5)' }}>{cardVisual.number}</div>
                    <div className="cc-row cc-bottom">
                        <div className="cc-owner">
                            <div className="cc-label" style={{ color: '#455a64' }}>KART SAHİBİ</div>
                            <div className="cc-value" style={{ color: '#37474f' }}>{cardVisual.owner}</div>
                        </div>
                        <div className="cc-exp">
                            <div className="cc-label" style={{ color: '#455a64' }}>SKT</div>
                            <div className="cc-value" style={{ color: '#37474f' }}>
                                <span>{cardVisual.month}</span>/<span>{cardVisual.year}</span>
                            </div>
                        </div>
                        <div className="cc-logo">
                            {cardVisual.cardLogo && (
                                <img src={cardVisual.cardLogo} width={72} height={24} style={{ objectFit: 'contain' }} alt={cardVisual.schema} />
                            )}
                        </div>
                    </div>
                    <div className="cc-amount" style={{ color: '#1565c0', textShadow: '0 1px 0 rgba(255,255,255,.5)' }}>{cardVisual.amount}</div>
                </div>
                {/* BACK */}
                <div className="credit-card__face credit-card__face--back" style={{ background: 'linear-gradient(135deg,#f5f5f5 0%,#e0e0e0 50%,#bdbdbd 100%)', color: '#2c3e50' }}>
                    <div className="cc-shine" />
                    <div className="cc-strip" />
                    <div className="cc-signature">
                        <span className="cc-cvv-label">CVV</span>
                        <span className="cc-cvv-value">{cardVisual.cvv}</span>
                    </div>
                    <div className="cc-back-logo">
                        {cardVisual.cardLogo && (
                            <img src={cardVisual.cardLogo} width={72} height={24} style={{ objectFit: 'contain' }} alt={cardVisual.schema} />
                        )}
                    </div>
                </div>
            </div>
        </div>

        {/* Yeni tahsilat ekranlarında aynı bilgi sağ sütundaki PaymentSecurityAside
            içinde zaten var; iki kez göstermemek için gizlenebilir. Eski ekranlar
            (InstantPaymentForm) prop'u geçmediğinden davranışları değişmez. */}
        {!hideSecurityNote && (
            <Alert color="light" className="mt-3">
                <div className="d-flex align-items-center">
                    <i className="bx bx-shield-check text-success me-2 fs-4" />
                    <div>
                        <small className="text-muted">
                            <strong>Güvenli Ödeme</strong><br />
                            Tüm ödeme bilgileriniz SSL ile şifrelenerek korunmaktadır.
                        </small>
                    </div>
                </div>
            </Alert>
        )}
    </div>
);

export default CreditCardPreview;